import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import AuctionForm from '../components/AuctionForm';
import { MODES, MODE_LABELS } from '../domain/constants';

// Portale unico: la modalita e una scelta nella pagina, non due pagine gemelle.

const ACTIONS = [
    ['create', 'Crea'],
    ['join', 'Entra'],
    ['spectate', 'Modalità spettatore'],
];

export default function AuctionPortal() {
    const [mode, setMode] = useState(MODES.LIVE);
    const [action, setAction] = useState('create');
    // Lo spettatore non sceglie niente: la modalita dell'asta gliela dice il
    // server, e il selettore sopra non avrebbe nessun effetto.
    const isSpectate = action === 'spectate';
    // Chi arriva qui perche' la sua lobby e' stata chiusa non deve trovare una
    // pagina di creazione muta: il motivo viaggia nello stato della
    // navigazione, che sopravvive al cambio di rotta ma non a un refresh.
    const notice = useLocation().state?.notice;

    return (
        <div className="app">
            <header className="app-header">
                <div className="app-brand">
                    <img src="/logos/seriea.png" alt="Serie A" />
                    <h1 className="u-truncate">
                        {isSpectate ? 'Modalità spettatore' : MODE_LABELS[mode]}
                    </h1>
                </div>
                <div className="app-actions">
                    <Link to="/" className="btn btn--ghost">
                        Home
                    </Link>
                </div>
            </header>

            <main className="app-main">
                <div className="panel panel-body stack">
                    {notice && (
                        <p className="notice notice--warn" role="alert">
                            {notice}
                        </p>
                    )}

                    {!isSpectate && (
                        <div className="btn-group" role="group" aria-label="Modalita">
                            {Object.values(MODES).map((value) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={`btn ${
                                        mode === value ? 'btn--primary' : 'btn--ghost'
                                    }`}
                                    onClick={() => setMode(value)}
                                >
                                    {MODE_LABELS[value]}
                                </button>
                            ))}
                        </div>
                    )}

                    <div className="btn-group" role="group" aria-label="Azione">
                        {ACTIONS.map(([value, label]) => (
                            <button
                                key={value}
                                type="button"
                                className={`btn ${action === value ? 'btn--primary' : 'btn--ghost'}`}
                                onClick={() => setAction(value)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>

                    <AuctionForm key={`${action}-${mode}`} action={action} mode={mode} />
                </div>
            </main>
        </div>
    );
}
